import { defineStore } from 'pinia'

export const userTabStore = defineStore('usertab', {
	state: () => ({
		options: {
			selectedtab: null
		}
	}),
	actions: {
	}
	// getters
	// actions
})
